<template>
  <span>
    <v-dialog v-model="dialogSendToFtp" @keydown.esc="onCancel" persistent width="500px">
      <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" circle class="mr-2">
            mdi-cloud-arrow-up-outline
          </v-icon>
      </template>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon dark @click="onCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Da li želite da pošaljete dokument na FTP?
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-actions>
          <v-btn color="error">Ne</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendToFtp" :loading="postingToApi">Pošalji</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar :isError="snackbar.isError" :text="snackbar.text" :showSnackbar.sync="snackbar.show">
    </snackbar>
  </span>
</template>

<script>
import * as documentsAPI from '../api/documents.js';
import Snackbar from './Snackbar.vue';

export default {
  components: { Snackbar },
  name: "SendToFtpDialog",
  data: function () {
    return {
      dialogSendToFtp: false,
      postingToApi: false,
      snackbar: {
        show : false,
        text : "",
        isError : false
      },
    }
  },
  props: {
    purchaseInvoiceId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onCancel () {
      this.dialogSendToFtp = false;
    },
    sendToFtp() {
      this.postingToApi = true;
      documentsAPI.sendToFtp(this.purchaseInvoiceId, this.$store.getters.token)
        .then(response => response)
        .then(() => {
          this.postingToApi = false;
          this.showNotification("Dokument je uspešno poslat na FTP");
        })
        .catch(() => {
          this.postingToApi = false;
          this.showError("Greška prilikom slanja dokumenta na FTP");
        })
    },
    showError(errorCode) {
      this.snackbar.text = errorCode;
      this.snackbar.isError = true;
      this.snackbar.show = true;
    },
    showNotification(text) {
      this.snackbar.text = text;
      this.snackbar.isError = false;
      this.snackbar.show = true;
    },
  }
}
</script>
